import { isMain } from '@/utils/tools'
// -------------------------------------------------------------
// 首页
let Index = () =>
  import( /* webpackChunkName: "group-index" */ '@/views/index/index')

// 课程详情页
let CourseDetails = () =>
  import( /* webpackChunkName: "group-course_details" */ '@/views/course/course_details/index')
let CourseContent = () =>
  import( /* webpackChunkName: "group-course_content" */ '@/views/course/course_content/index')
let DetailsNew = () =>
  import( /* webpackChunkName: "group-detailsNew" */ '@/views/course/course_details/detailsNew')
let Details = () =>
  import( /* webpackChunkName: "group-details" */ '@/views/course/course_details/details')
let DetailsOld = () =>
  import( /* webpackChunkName: "group-detailsOld" */ '@/views/course/course_details/detailsOld')
// 课程分组资料
let Information = () =>
  import( /* webpackChunkName: "group-Information" */ '@/views/course/information/index')

// 课程购买成功页面
let BuySuccess = () =>
  import( /* webpackChunkName: "group-buy_success" */ '@/views/course/buy_success/index')

// 新生报道页面
let MentorWechat = () =>
  import( /* webpackChunkName: "group-mentor_wechat" */ '@/views/course/mentor_wechat/index')

// 项目列表页面
let List = () =>
  import( /* webpackChunkName: "group-list" */ '@/views/course/list/index')
// 课程个人报告页面
let PersonReportNew = () =>
  import( /* webpackChunkName: "group-person_report_new" */ '@/views/course/person_report_new/index')
// 课程项目详情页面

let ProjectDetails = () =>
  import( /* webpackChunkName: "group-project_details" */ '@/views/course/project_details/index')

// 课程项目报告页面
let ProjectReport = () =>
  import( /* webpackChunkName: "group-project_report" */ '@/views/course/project_report/index')
// 课程项目攻略列表页面
let FaqList = () =>
  import( /* webpackChunkName: "group-faq_list" */ '@/views/course/faq_list/index')
// 课程项目攻略内容页面
let FaqContent = () =>
  import( /* webpackChunkName: "group-faq_content" */ '@/views/course/faq_content/index')
// 课程扩展阅读页面
let FurtherReading = () =>
  import( /* webpackChunkName: "group-further_reading" */ '@/views/course/further_reading/index')
// 课程大神导师团页面
let Valuation = () =>
  import( /* webpackChunkName: "group-valuation" */ '@/views/course/valuation/index')
// 课程自查清单页面
let CheckContent = () =>
  import( /* webpackChunkName: "group-check_content" */ '@/views/course/check_content/index')
// 课程难词表页面
let DifficultWords = () =>
  import( /* webpackChunkName: "group-difficult_words" */ '@/views/course/difficult_words/index')
// 课程P0任务页面
let Project0Task = () =>
  import( /* webpackChunkName: "group-project0_task" */ '@/views/course/project0_task/index')
// 课程P1任务页面1
let Project1Task1New = () =>
  import( /* webpackChunkName: "group-project1_task" */ '@/views/course/project1_task1_new/index')
// 课程P1任务页面2
let Project1Task2New = () =>
  import( /* webpackChunkName: "group-project1_task" */ '@/views/course/project1_task2_new/index')
// 课程P1任务页面3
let Project1Task3New = () =>
  import( /* webpackChunkName: "group-project1_task" */ '@/views/course/project1_task3_new/index')
let Project1IndReport = () =>
  import( /* webpackChunkName: "group-project1_ind_report" */ '@/views/course/project1_ind_report/index')

// 课程P2任务页面
let Project2Task1New = () =>
  import( /* webpackChunkName: "group-project2_task1_new" */ '@/views/course/project2_task1_new/index')

let Project2Task2New = () =>
  import( /* webpackChunkName: "group-project2_task2_new" */ '@/views/course/project2_task2_new/index')

let Project2Task3New = () =>
  import( /* webpackChunkName: "group-project2_task3_new" */ '@/views/course/project2_task3_new/index')
// 课程P3任务页面
let Project3Task1New = () =>
  import( /* webpackChunkName: "group-project3_task1_new" */ '@/views/course/project3_task1_new/index')
// 课程P3任务2
let Project3Task2New = () =>
  import( /* webpackChunkName: "group-project3_task1_new" */ '@/views/course/project3_task2_new/index')
// 课程P3任务3
let Project3Task3New = () =>
  import( /* webpackChunkName: "group-project3_task1_new" */ '@/views/course/project3_task3_new/index')

// 课程P4任务页面
let Project4Task1New = () =>
  import( /* webpackChunkName: "group-project4_task1_new" */ '@/views/course/project4_task1_new/index')

let Project4Task2New = () =>
  import( /* webpackChunkName: "group-project4_task2_new" */ '@/views/course/project4_task2_new/index')
let Project4Task3New = () =>
  import( /* webpackChunkName: "group-project4_task3_new" */ '@/views/course/project4_task3_new/index')
// 课程P3项目彩蛋页面
let Project3Eggs = () =>
  import( /* webpackChunkName: "group-project3_eggs" */ '@/views/course/project3_eggs/index')
// 分享好友听课页
let GiveShare = () =>
  import( /* webpackChunkName: "group-give_share" */ '@/views/course/give_share/index')
// 课程全部作业
let AllHomework = () =>
  import( /* webpackChunkName: "group-all_homework" */ '@/views/course/all_homework/index')

// 课程自由对话
let courseDialogue = () =>
  import( /* webpackChunkName: "group-course_dialogue" */ '@/views/course/course_dialogue/index')
// 课程自由对话 - PC
let courseDialoguePc = () =>
  import( /* webpackChunkName: "group-course_dialogue_pc" */ '@/views/course/course_dialogue_pc/index')

// 我的页面
let Person = () =>
  import( /* webpackChunkName: "group-person" */ '@/views/person/person/index')
// 我的小组页面
let Team = () =>
  import( /* webpackChunkName: "group-team" */ '@/views/person/team/index')

// 团队组建-讨论成果
let Edit = () =>
  import( /* webpackChunkName: "group-edit" */ '@/views/person/edit/index')

// 新的页面-课程报告页
let ProjectReportNew = () =>
  import( /* webpackChunkName: "group-project_report_new" */ '@/views/course/project_report_new/index')

// 我的账户
let MyAccount = () =>
  import( /* webpackChunkName: "group-my_account" */ '@/views/person/my_account/index')
// 我的邀请
let MyInvitation = () =>
  import( /* webpackChunkName: "group-my_invitation" */ '@/views/person/my_invitation/index')
// 达成成就
let Achievement = () =>
  import( /* webpackChunkName: "group-achievement" */ '@/views/person/achievement/index')
// 我的证书
let Certificate = () =>
  import( /* webpackChunkName: "group-certificate" */ '@/views/person/certificate/index')


// 辅导详情页
let MentorDetails = () =>
  import( /* webpackChunkName: "group-mentor_details" */ '@/views/totoring/mentor_details/index')

// 辅导职能职位
let TotoringChoose = () =>
  import( /* webpackChunkName: "group-tototing_choose" */ '@/views/totoring/totoring_choose/index')

// 辅导个人资料
let totoringInformations = () =>
  import( /* webpackChunkName: "group-totoring_informations" */ '@/views/totoring/informations/index')

// 导师列表页面
let MentorList = () =>
  import( /* webpackChunkName: "group-mentor_list" */ '@/views/totoring/mentor_list/index')

// 导师信息页面
let MentorInformation = () =>
  import( /* webpackChunkName: "group-mentor_information" */ '@/views/totoring/mentor_information/index')

// 选择辅导时间
let totoringCoachingTime = () =>
  import( /* webpackChunkName: "group-coaching_time" */ '@/views/totoring/coaching_time/index')
// 辅导流程
let totoringBuySuccess = () =>
  import( /* webpackChunkName: "group-buy_success" */ '@/views/totoring/buy_success/index')
// 辅导知情通知书
let totoringConsentForm = () =>
  import( /* webpackChunkName: "group-consent_form" */ '@/views/totoring/consent_form/index')
// 辅导前准备
let totoringConsentNeed = () =>
  import( /* webpackChunkName: "group-consent_need" */ '@/views/totoring/consent_need/index')
// 添加咨询师
let totoringMentorWechat = () =>
  import( /* webpackChunkName: "group-mentor_wechat" */ '@/views/totoring/mentor_wechat/index')
// 客户评价
let MentorEvaluation = () =>
  import( /* webpackChunkName: "group-mentor_evaluation" */ '@/views/totoring/mentor_evaluation/index')
// 辅导报告
let MentorReport = () =>
  import( /* webpackChunkName: "group-mentor_report" */ '@/views/totoring/mentor_report/index')
//导师验证
let MentorPhone = () =>
  import( /* webpackChunkName: "group-mentor_phone" */ '@/views/totoring/mentor_phone/index')

// 客户点评
let StudentEvaluation = () =>
  import( /* webpackChunkName: "group-student_evaluation" */ '@/views/totoring/student_evaluation/index')


// 选修课任务一
let projectTloneTask1 = () =>
  import( /* webpackChunkName: "group-project_alone_task1" */ '@/views/course/project_alone_task1/index')
// 选修课任务二
let projectTloneTask2 = () =>
  import( /* webpackChunkName: "group-project_alone_task2" */ '@/views/course/project_alone_task2/index')



// 排行榜
let Fission = () =>
  import( /* webpackChunkName: "group-fission" */ '@/views/other/fission/index')
// 讲座排行榜
let FissionLecture = () =>
  import( /* webpackChunkName: "group-fission_lecture" */ '@/views/other/fission_lecture/index')
//生涯日历
let careerCalendar = () =>
  import( /* webpackChunkName: "group-career-calendar" */ '@/views/other/career_calendar/index')
//生涯日历 -- 海报
let calendarPoster = () =>
  import( /* webpackChunkName: "group-calendar_poster" */ '@/views/other/career_calendar/calendar_poster/index')


// 纯动态任务 全数据类型
let projectDynamic = () =>
  import( /* webpackChunkName: "group-project_dynamic" */ '@/views/course/project_dynamic/index')

// 我的课程列表
let myCourse = () =>
  import( /* webpackChunkName: "group-my_course" */ '@/views/person/my_course/index')



// 我的课程订单详情
let myCourseDetails = () =>
  import( /* webpackChunkName: "group-my_course_details" */ '@/views/person/my_course_details/index')

// 我的课程退款申请
let myCourseRefund = () =>
  import( /* webpackChunkName: "group-my_course_refund" */ '@/views/person/my_course_refund/index')

// 我的课程退款详情
let myCourseRefundDetails = () =>
  import( /* webpackChunkName: "group-my_course_refund_details" */ '@/views/person/my_course_refund_details/index')

// 我的课程调期选择
let myCourseSwaps = () =>
  import( /* webpackChunkName: "group-my_course_swaps" */ '@/views/person/my_course_swaps/index')

// 新的课程详情1
let detailsActive = () =>
  import( /* webpackChunkName: "group-detailsActive" */ '@/views/course/course_details/detailsActive')

// 新的课程详情2
let detailsBash = () =>
  import( /* webpackChunkName: "group-detailsBash" */ '@/views/course/course_details/detailsBash')

// 活动详情
let eventDetails = () =>
  import( /* webpackChunkName: "group-event_details" */ '@/views/course/event_details/index')

// 我要赚钱
let makeMoney = () =>
  import( /* webpackChunkName: "group-make_money" */ '@/views/course/make_money/index')

// 成为助教
let taInformations = () =>
  import( /* webpackChunkName: "group-ta_informations" */ '@/views/course/ta_informations/index')
// 助教招募
let taAskforResult = () =>
  import( /* webpackChunkName: "group-ta_askfor_result" */ '@/views/course/ta_askfor_result/index')
// 助教期次列表
let taPeriodTimeList = () =>
  import( /* webpackChunkName: "group-ta_period_time_list" */ '@/views/course/ta_period_time_list/index')
// 助教学员信息
let taStudentInformation = () =>
  import( /* webpackChunkName: "group-ta_student_information" */ '@/views/course/ta_student_information/index')
// 助教报告
let taProjectReport = () =>
  import( /* webpackChunkName: "group-ta_report" */ '@/views/course/ta_project_report/index')
// 助教项目列表
let taProjectList = () =>
  import( /* webpackChunkName: "group-ta_project_list" */ '@/views/course/ta_project_list/index')
// 助教项目详情
let taProjectDetails = () =>
  import( /* webpackChunkName: "group-ta_project_details" */ '@/views/course/ta_project_details/index')
// 助教信息
let assistantInfo = () =>
  import( /* webpackChunkName: "group-assistant_info" */ '@/views/course/assistant_info/index')

// 助教学员基础数据
let taBasicData = () =>
  import( /* webpackChunkName: "group-ta_project_details" */ '@/views/course/ta_basic_data/index')

// 课程拼团
let courseSpell = () =>
  import( /* webpackChunkName: "group-course_spell" */ '@/views/course/course_spell/index')



// 个人战略课程调研问卷
let surveyQuestionnaire = () =>
  import( /* webpackChunkName: "group-survey_questionnaire" */ '@/views/course/survey_questionnaire/index')

// 推广中心
let promotionCenter = () =>
  import( /* webpackChunkName: "group-promotion_center" */ '@/views/person/promotion_center/index')
// 推广邀请列表
let promotionList = () =>
  import( /* webpackChunkName: "group-promotion_list" */ '@/views/person/promotion_list/index')

// 课程连报
let courseQuote = () =>
  import( /* webpackChunkName: "group-course_quote" */ '@/views/course/course_quote/index')
// 课程测验
let knowledgeTest = () => import( /* webpackChunkName: "group-knowledge_test" */ '@/views/course/knowledge_test/index')
// 课程测验 -- 知识卡片
let knowledgeCard = () => import( /* webpackChunkName: "group-knowledge_card" */ '@/views/course/knowledge_card/index')
//案例分析
let caseAnalysis = () => import( /* webpackChunkName: "group-case_analysis" */ '@/views/course/case_analysis/index')
//海报生成
let posterGeneration = () => import( /* webpackChunkName: "group-poster_generation" */ '@/views/course/poster_generation/index')


// ------------------------------------------------------------
// 上线判断

if (!isMain()) {
  taInformations = () => import( /* webpackChunkName: "group-ta_informations" */ '@/views/course/ta_informations/index.v2')
}

export default [{
  path: '/',
  redirect: '/index'
}, {
  path: '/index', //
  name: '新精英人才加速器',
  component: Index
}, {
  path: '/mentor_details', //
  name: '定制你的竞争力',
  component: MentorDetails
}, {
  path: '/course_details', //
  name: '',
  // component: CourseDetails
  component: Details
}, {
  path: '/details_new', //
  name: '个人战略—商业价值重塑课',
  // component: detailsBash
  component: Details
}, {
  path: '/details_old', //
  name: '个人战略—商业价值重塑课',
  component: Details
}, {
  path: '/buy_success', //
  name: '',
  component: BuySuccess
}, {
  path: '/mentor_wechat', //
  name: '新生报到',
  component: MentorWechat
}, {
  path: '/list', //
  name: '',
  component: List
}, {
  path: '/person_report_new', //
  name: '',
  component: PersonReportNew
}, {
  path: '/project_details', //
  name: '',
  component: ProjectDetails
}, {
  path: '/project_report', //
  name: '加载中',
  component: ProjectReport
}, {
  path: '/project_report_new', //
  name: '个人战略—商业价值重塑课',
  component: ProjectReportNew
}, {
  path: '/course_content', //
  name: '',
  component: CourseContent
}, {
  path: '/information', //
  name: '分组资料',
  component: Information
}, {
  path: '/faq_list', //
  name: '项目攻略',
  component: FaqList
}, {
  path: '/faq_content', //
  name: '项目攻略',
  component: FaqContent
}, {
  path: '/further_reading', //
  name: '扩展阅读',
  component: FurtherReading
}, {
  path: '/valuation', //
  name: '大神导师团',
  component: Valuation
}, {
  path: '/check_content', //
  name: '自查清单',
  component: CheckContent
}, {
  path: '/difficult_words', //
  name: '难词表',
  component: DifficultWords
}, {
  path: '/project0_task', //
  name: 'P0:项目导入',
  component: Project0Task
}, {
  path: '/project_dynamic',
  name: '动态任务',
  component: projectDynamic
}, {
  path: '/project1_task1_new',
  name: 'P1:任务一',
  component: Project1Task1New
}, {
  path: '/project1_ind_report',
  name: 'P1:行业调研',
  component: Project1IndReport
}, {
  path: '/project1_task2_new',
  name: 'P1:任务二',
  component: Project1Task2New
}, {
  path: '/project1_task3_new',
  name: 'P1:任务三',
  component: Project1Task3New
}, {
  path: '/project3_task1_new',
  name: 'P3:任务一',
  component: Project3Task1New
}, {
  path: '/project3_task2_new',
  name: 'P3:任务二',
  component: Project3Task2New
}, {
  path: '/project3_task3_new',
  name: 'P3:任务三',
  component: Project3Task3New
}, {
  path: '/project3_eggs',
  name: 'P3:彩蛋',
  component: Project3Eggs
}, {
  path: '/project2_task1_new',
  name: 'P2:任务一',
  component: Project2Task1New
}, {
  path: '/project2_task2_new',
  name: 'P2:任务二',
  component: Project2Task2New
}, {
  path: '/project2_task3_new',
  name: 'P2:任务三',
  component: Project2Task3New
}, {
  path: '/project4_task1_new',
  name: 'P4:任务一',
  component: Project4Task1New
}, {
  path: '/project4_task2_new',
  name: 'P4:任务二',
  component: Project4Task2New
}, {
  path: '/project4_task3_new',
  name: 'P4:任务三',
  component: Project4Task3New
}, {
  path: '/project_alone_task1',
  name: '选修课:任务一',
  component: projectTloneTask1
}, {
  path: '/project_alone_task2',
  name: '选修课:任务二',
  component: projectTloneTask2
}, {
  path: '/all_homework',
  name: '全部作业',
  component: AllHomework
}, {
  path: '/give_share',
  name: '分享好友听课',
  component: GiveShare
}, {
  path: '/person',
  name: '我的',
  component: Person
}, {
  path: '/team',
  name: '我的小组',
  component: Team
}, {
  path: '/edit',
  name: '团队组建',
  component: Edit
}, {
  path: '/my_account',
  name: '我的账户',
  component: MyAccount
}, {
  path: '/my_invitation',
  name: '我的邀请',
  component: MyInvitation
}, {
  path: '/achievement',
  name: '达成成就',
  component: Achievement
}, {
  path: '/certificate',
  name: '我的证书',
  component: Certificate
}, {
  path: '/totoring_coaching_time', //
  name: '选择辅导时间',
  component: totoringCoachingTime
}, {
  path: '/totoring_buy_success', //
  name: '辅导流程',
  component: totoringBuySuccess
}, {
  path: '/totoring_consent_form', //
  name: '生涯辅导知情同意书',
  component: totoringConsentForm
}, {
  path: '/totoring_consent_need', //
  name: '辅导前准备',
  component: totoringConsentNeed
}, {
  path: '/totoring_mentor_wechat', //
  name: '添加咨询师',
  component: totoringMentorWechat
}, {
  path: '/totoring_choose', //
  name: '选择目标职位',
  component: TotoringChoose
}, {
  path: '/totoring_informations', //
  name: '个人资料',
  component: totoringInformations
}, {
  path: '/mentor_list', //
  name: '咨询师列表',
  component: MentorList
}, {
  path: '/mentor_information', //
  name: '咨询师信息',
  component: MentorInformation
}, {
  path: '/mentor_evaluation', //
  name: '客户评价',
  component: MentorEvaluation
}, {
  path: '/mentor_report', //
  name: '辅导报告',
  component: MentorReport
}, {
  path: '/mentor_phone', //
  name: '导师验证',
  component: MentorPhone
}, {
  path: '/student_evaluation', //
  name: '客户点评',
  component: StudentEvaluation
}, {
  path: '/fission', //
  name: '排行榜',
  component: Fission
}, {
  path: '/fission_lecture', //
  name: '排行榜',
  component: FissionLecture
}, {
  path: '/career_calendar', //
  name: '新精英生涯日历',
  component: careerCalendar
}, {
  path: '/calendar_poster', //
  name: '新精英生涯日历',
  component: calendarPoster
}, {
  path: '/my_course', //
  name: '我的课程',
  component: myCourse
}, {
  path: '/my_course_details', //
  name: '订单详情',
  component: myCourseDetails
}, {
  path: '/my_course_swaps', //
  name: '调整期次',
  component: myCourseSwaps
}, {
  path: '/my_course_refund', //
  name: '退款申请',
  component: myCourseRefund
}, {
  path: '/my_course_refund_details', //
  name: '退款详情',
  component: myCourseRefundDetails
}, {
  path: '/details_bash', //
  name: '新课程详情',
  component: detailsBash,
}, {
  path: '/details_active', //
  name: '新课程详情',
  component: detailsActive,
}, {
  path: '/event_details', //
  name: '活动详情',
  component: eventDetails,
}, {
  path: '/make_money', //
  name: '推荐有礼',
  component: makeMoney,
}, {
  path: '/ta_informations', //
  name: '助教招募-PBL学习促动师',
  component: taInformations,
}, {
  path: '/ta_askfor_result', //
  name: '助教招募-PBL学习促动师',
  component: taAskforResult,
}, {
  path: '/ta_period_time_list', //
  name: '我是助教',
  component: taPeriodTimeList,
}, {
  path: '/ta_student_information', //
  name: '学员资料',
  component: taStudentInformation,
}, {
  path: '/ta_project_list', //
  name: '助教项目列表',
  component: taProjectList,
}, {
  path: '/ta_project_report', //
  name: '助教报告',
  component: taProjectReport,
}, {
  path: '/ta_project_details', //
  name: '助教项目详情',
  component: taProjectDetails,
},  {
  path: '/ta_basic_data', //
  name: '助教项目详情',
  component: taBasicData,
},{
  path: '/assistant_info', //
  name: 'PBL学习促动师',
  component: assistantInfo,
}, {
  path: '/course_spell', //
  name: '拼团',
  component: courseSpell,
}, {
  path: '/survey_questionnaire', //个人战略课程调研问卷
  name: '个人战略课程调研问卷',
  component: surveyQuestionnaire,
}, {
  path: '/promotion_center',
  name: '推广中心',
  component: promotionCenter,
}, {
  path: '/promotion_list',
  name: '我的推广',
  component: promotionList,
}, {
  path: '/course_quote',
  name: '人才加速器',
  component: courseQuote,
}, {
  path: '/course_dialogue',
  name: '自我对话',
  component: courseDialogue,
}, {
  path: '/course_dialogue_pc',
  name: 'PC端自我对话操作流程',
  component: courseDialoguePc,
},
{
  path: '/knowledge_test',
  name: '加载中',
  component: knowledgeTest,
},
{
  path: '/knowledge_card',
  name: '加载中',
  component: knowledgeCard,
},
{
  path: '/case_analysis',
  name: '加载中',
  component: caseAnalysis,
},
{
  path: '/poster_generation',
  name: '加载中',
  component: posterGeneration,
}
];
